"use client";

import { CategoryFaq, ProdDetailFaq } from "@/services/dataTypes";
import { useState } from "react";

interface Props {
  faq: CategoryFaq | ProdDetailFaq;
  index: number;
}

const CategoryFaqsAccordion = ({ faq, index }: Props) => {
  const [open, setOpen] = useState(index === 0);

  return (
    <div className="border border-gray-100 rounded-xl overflow-hidden mb-3">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-gray-50 transition-colors"
        aria-expanded={open}
      >
        <span className="text-[#111318] font-semibold text-sm pr-4">
          {faq.question}
        </span>
        <span
          className={`flex-shrink-0 w-6 h-6 rounded-full bg-[#ff912f] flex items-center justify-center text-white text-sm font-bold transition-transform duration-200 ${
            open ? "rotate-45" : ""
          }`}
        >
          +
        </span>
      </button>
      {open && (
        <div className="px-5 py-4 bg-gray-50 text-sm text-gray-600 leading-relaxed border-t border-gray-100">
          {faq.answer}
        </div>
      )}
    </div>
  );
};

export default CategoryFaqsAccordion;
